import {
  API_ROUTES,
  type BuildExportRequest,
  exportReadinessSchema,
  exportSummarySchema,
} from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from './queries.js';

/** Export queries. */

export const exportKeys = {
  all: (organizationId: string) => ['exports', organizationId] as const,
} as const;

export const exportsQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['exports', organizationId, 'list'] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.exports.list(organizationId),
        schema: z.array(exportSummarySchema),
        signal,
      }),
  });

export const exportReadinessQuery = (organizationId: string, from: string, to: string) =>
  queryOptions({
    queryKey: ['exports', organizationId, 'readiness', from, to] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: `${API_ROUTES.exports.readiness(organizationId)}?from=${from}&to=${to}`,
        schema: exportReadinessSchema,
        signal,
      }),
  });

export async function buildExport(organizationId: string, body: BuildExportRequest) {
  return apiClient.request({
    method: 'POST',
    path: API_ROUTES.exports.create(organizationId),
    schema: exportSummarySchema,
    body,
  });
}

/**
 * The download URL.
 *
 * Handed to the browser rather than fetched: this endpoint returns a file, not
 * an envelope, and the browser's own save dialog is a better experience than
 * anything reconstructed from a blob.
 */
export function exportDownloadPath(organizationId: string, exportId: string): string {
  return API_ROUTES.exports.download(organizationId, exportId);
}
